import React, { useContext, useEffect, useState } from 'react'
import { EventMetaContext } from '../SingleEvent'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import { Avatar, Stack, Typography } from '@mui/material'
import API from '../../../../services/API'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import moment from 'moment'
import BigModal from '../../../../components/Modals/BigModal'

// Controlled modal — the Shifts panel's actions menu opens it.
const RejectedShiftApplications = ({ open, onClose }) => {
  const { eventMeta } = useContext(EventMetaContext)
  const [rejectedApplications, setRejectedApplications] = useState([])

  useEffect(() => {
    if (!open) return
    API.post('/rejected-shift-applications', {
      rejectedShiftApplications: eventMeta.rejectedShiftApplications,
    }).then((res) => {
      if (res.status === 200) {
        setRejectedApplications(res.data)
      }
    })
  }, [open])

  return (
    <BigModal
      open={open}
      onClose={onClose}
      style={{ padding: 0, borderRadius: 3 }}
    >
      <DetailsBox title="Rejected Shift Applications">
        <Typography variant="caption">
          The following staff had shift applications rejected, and so may
          still be available for this event.
        </Typography>
        <CustomDataGrid
          rows={rejectedApplications}
          getRowId={(row) => row._id}
          slots={{
            footer: () => null,
          }}
          hideToolbar
          columns={[
            {
              field: 'applicant',
              headerName: 'Employee',
              minWidth: 200,
              flex: 1,
              valueGetter: (value, row) => row.employee.id,
              renderCell: ({ row }) => (
                <Stack direction="row" gap={1} alignItems="center">
                  <Avatar
                    src={row.employee.userAccount.photograph}
                    sx={{ width: 20, height: 20 }}
                  />
                  <>
                    {row.employee.userAccount.firstName}{' '}
                    {row.employee.userAccount.lastName}
                  </>
                </Stack>
              ),
            },
            {
              field: 'shiftStart',
              headerName: 'Shift Start',
              valueGetter: (value, row) => row?.shift?.start,
              renderCell: ({ row }) =>
                row.shift
                  ? moment(row.shift.start).format('ddd Do HH:mm')
                  : 'Shift Deleted',
              minWidth: 150,
              flex: 0.7,
            },
            {
              field: 'shiftEnd',
              headerName: 'Shift End',
              valueGetter: (value, row) => row?.shift?.end,
              renderCell: ({ row }) =>
                row.shift
                  ? moment(row.shift.end).format('ddd Do HH:mm')
                  : 'Shift Deleted',
              minWidth: 150,
              flex: 0.7,
            },
            {
              field: 'assignment',
              headerName: 'Event Role',
              valueGetter: (value, row) => row?.shift?.eventAssignment,
              minWidth: 200,
              flex: 0.8,
            },
            {
              field: 'rejectedReason',
              headerName: 'Rejected Reason',
              minWidth: 200,
              flex: 1,
            },
          ]}
        />
      </DetailsBox>
    </BigModal>
  )
}

export default RejectedShiftApplications
